import Box from "react-raster";
import React from "react";
import styled from "styled-components";

import ButtonLink from "../ButtonLink";
import Container from "../Container";
import { H2, Copy, Eyebrow } from "../Typography";
import HorizontalCard from "./HorizontalCard";
import Statistic from "../Statistics/Statistic";

export const Wrapper = styled.div`
  background-color: ${({ theme, backgroundColour }) =>
    backgroundColour && theme.colours[backgroundColour]};

  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};

  @media (${({ theme }) => theme.mq.l}) {
    padding-bottom: ${({ $hasBottomMargin }) =>
      $hasBottomMargin ? "60px" : "20px"};
    padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
  }
`;

const LinkWrapper = styled.div`
  color: ${({ theme }) => theme.colours.grey};
  display: flex;
  align-items: center;
  width: max-content;
  margin-bottom: 30px;
`;

function NarrowRightAligned({
  description,
  descriptionColour,
  cards = [],
  mainTitle,
  titleColour,
  backgroundColour,
  hasTopMargin,
  hasBottomMargin,
  hideTitle,
  hideIndexNumberDisplay,
  eyebrow,
  ctaProps,
}) {
  const { ctaLabel, ctaUrl } = ctaProps || {};
  return (
    <Wrapper
      backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container>
        {eyebrow && (
          <Box cols={6}>
            <Eyebrow colour={titleColour || "grey"} marginBottom="0px">
              {eyebrow}
            </Eyebrow>
          </Box>
        )}
        {(mainTitle || description) && (
          <Box cols={[6, 6]} marginRight={[0, 6]}>
            {!hideTitle && mainTitle && (
              <H2 $colour={titleColour}>{mainTitle}</H2>
            )}
            {description && (
              <Copy
                style={{ marginBottom: "90px" }}
                colour={descriptionColour}
                columnCount={2}
              >
                {description}
              </Copy>
            )}
          </Box>
        )}
        {cards.map((card, i) => {
          if (card.__typename === "ContentfulStatistic") {
            return (
              <Box marginBottom={1} cols={[6, 12]} key={card.id}>
                <Statistic slidesIn stat={card} colour={descriptionColour} />
              </Box>
            );
          }

          return (
            <Box
              marginBottom={1}
              cols={[6, 12, 6]}
              marginLeft={[0, 0, 6]}
              key={card.id}
            >
              <HorizontalCard
                number={i + 1}
                hideIndexNumberDisplay={hideIndexNumberDisplay}
                {...card}
              />
            </Box>
          );
        })}
        {ctaUrl && (
          <LinkWrapper>
            <ButtonLink
              isWhite={!!(!backgroundColour || backgroundColour === "default")}
              label={ctaLabel}
              url={ctaUrl}
            />
          </LinkWrapper>
        )}
      </Container>
    </Wrapper>
  );
}

export default NarrowRightAligned;
